/*
 * Copyright (c) 2025 Hardfin, Inc.
 */
import { Assembly } from '@/assembly/api/types';
import { RegisterAssemblyFormData } from '@/assembly/components/register-assembly-dialog';
import { RegisterAssemblyPartRow } from '@/assembly/components/register-assembly-part-row';
import { Chip, Grid, Paper, Stack, Typography } from '@mui/material';
import { Control } from 'react-hook-form';

interface Props {
  assembly: Assembly;
  control: Control<RegisterAssemblyFormData>;
}

export function RegisterAssemblyParts(props: Props) {
  const serializedParts = props.assembly.partsUsed.filter(
    (item) => item.shouldRenderSerialFields
  );
  const nonSerializedParts = props.assembly.partsUsed.filter(
    (item) => !item.shouldRenderSerialFields
  );

  return (
    <>
      {serializedParts.map((item, index) => (
        <Grid item xs={12} key={item.key}>
          <RegisterAssemblyPartRow
            idx={index}
            control={props.control}
            item={item}
          />
        </Grid>
      ))}
      {nonSerializedParts.map((item) => (
        <Grid item xs={12} key={item.key}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              spacing={1}
              alignItems={'center'}
            >
              <Stack>
                <Typography variant="subtitle2">{item.sku}</Typography>
                <Typography variant="body2">{item.name}</Typography>
              </Stack>
              <Chip label={`${item.actualQuantity} units`} />
            </Stack>
          </Paper>
        </Grid>
      ))}
    </>
  );
}
